import { baseThemeValues } from 'constants/common';

const tabFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '13px',
  fontWeight: 500,
};

export const routingRulesetGroupEditTheme = {
  group: {
    bg: 'palette.tertiary.10',
    title: 'palette.tertiary.95',
  },
  icon: 'palette.tertiary.70',
  info: {
    bg: 'palette.primary.30',
    borderRadius: '8px',
    text: 'palette.primary.95',
  },
  timer: {
    counter: 'palette.tertiary.70',
    field: {
      bg: 'palette.surface.4',
      borderColor: 'palette.tertiary.20',
      borderRadius: '8px',
      borderWidth: '1px',
    },
    label: 'palette.tertiary.95',
    note: 'palette.tertiary.70',
    tab: {
      active: {
        ...tabFont,
        bg: 'palette.primary.20',
        text: 'palette.white',
      },
      base: {
        ...tabFont,
        bg: 'palette.transparent',
        text: 'palette.tertiary.70',
      },
      borderColor: 'palette.tertiary.20',
      borderWidth: '1px',
      hover: {
        ...tabFont,
        bg: 'palette.surface.5',
        text: 'palette.tertiary.95',
      },
    },
  },
};
